import {atom} from "recoil";

/**
 * 로그인 상태
 * @type {RecoilState<boolean}>}
 */
export const loginState = atom({
    key: "loginState",
    default: false, 
})